import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import LogRocket from 'logrocket';

import history from './history';
import rootReducer from './reducers/index';
import { authInitialState } from './reducers/authReducer';
import { userInitialState } from './reducers/userReducer';

import { getKeys } from './utils/helpers/storageManager';

const nextRootReducer = require('./reducers/index');

let composeEnhancers = compose;

if (process.env.NODE_ENV !== 'production')
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const authReducerProperties = getKeys('token');

const authReducerPreloadState = {
  ...authInitialState,
  ...authReducerProperties,
};

let userReducerProperties = getKeys(
  'userId',
  'email',
  'name',
  'profileId',
  'partner',
  'referenceCode'
);
const permissions = JSON.parse(getKeys('permissions').permissions);
userReducerProperties = {
  ...userReducerProperties,
  permissions: permissions || [],
};

const userReducerPreloadState = {
  ...userInitialState,
  ...userReducerProperties,
};

const storePreloadedState = {
  auth: authReducerPreloadState,
  user: userReducerPreloadState,
};

const middleware = routerMiddleware(history);

export default function configureStore() {
  const store = createStore(
    rootReducer,
    storePreloadedState,
    composeEnhancers(
      applyMiddleware(middleware, thunk, LogRocket.reduxMiddleware())
    )
  );
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      store.replaceReducer(nextRootReducer);
    });
  }
  //
  // store.subscribe(() => {
  //   console.log('store changed', store.getState())
  // })
  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js